import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {skipUntil, switchMap} from 'rxjs/operators';
import {activityApi} from '@/api/activity';
import {CHANNEL, SCENE} from '@/modules/referral-friends/const';
import {InviteeNotMatchReason} from './const';
import {browser$} from '@/streams/browser';
import {referralApi} from '@/api/referral';
import {isLogin$} from '@/streams/auth';

export const notMatchReason$ = new BehaviorSubject(0);

export const loadUserReferralType$ = new Subject();
export const query$ = new Subject();
export const depositStatus$ = new BehaviorSubject(false);
export const kycInfo$ = new BehaviorSubject(genInitKycInfo());

const typeReasonMap = {
  KOL: InviteeNotMatchReason.KOLChannel,
  HAS_REGISTER: InviteeNotMatchReason.Registered,
  NO_REFERRAL: InviteeNotMatchReason.NoInvitation,
};

loadUserReferralType$
  .pipe(
    skipUntil(browser$),
    switchMap(() => activityApi.getUserReferralType(CHANNEL, SCENE))
  )
  .subscribe(({data}) => {
    if (data) {
      for (const type in typeReasonMap) {
        if (data.statusType && data.statusType === type) {
          notMatchReason$.next(typeReasonMap[type]);
          return;
        }
      }
    }
    notMatchReason$.next(-1);
  });

combineLatest([query$.pipe(skipUntil(browser$)), isLogin$])
  .pipe(switchMap(([query, isLogin]) => (!isLogin ? [] : Promise.all([getDepositStatus(query), getKycStatus(query)]))))
  .subscribe(([depositInfo = {}, kycInfo]) => {
    depositStatus$.next(depositInfo.depositStatus);
    kycInfo$.next(kycInfo);
  });

async function getDepositStatus(query) {
  const {data, error} = await referralApi.getDepositStatus(query);
  if (data) {
    return {...data};
  }
  if (error) {
    return {depositStatus: false};
  }
}

async function getKycStatus(query) {
  const {data, error} = await referralApi.getKycStatus(query);
  if (data) {
    return data;
  }
  if (error) {
    return genInitKycInfo();
  }
}

function genInitKycInfo() {
  return {advanceKycStatus: '', basicKycStatus: ''};
}
